import * as React from 'react';
import { OrderStatus } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
const StepbarPayload = React.memo(props => {
    const { t } = useTranslation('Stepbar');
    const theme = useTheme('Checkout').Stepbar;
    if (props.orderStatus === OrderStatus.Confirmed) {
        const features = [];
        if (props.canAddServices) {
            features.push(t('add services'));
        }
        if (props.exchangeAvailable) {
            features.push(t('change dates'));
        }
        if (!!features.length) {
            return React.createElement("div", { className: theme.additional }, t('You can {{payload}}', { payload: features.join(', ') }));
        }
    }
    return null;
});
export default StepbarPayload;
